import clsx from 'clsx';
import { FC } from 'react';
import { Stack, StackProps } from '../../stack';
import classes from './actions.module.scss';

export type CardActionsProps = StackProps & {
  /**
   * Determine if the actions are positioned absolutely or relative within the card.
   * Usually when using with a visual header, the position is `absolute` otherwise it relative
   *
   * @default 'relative'
   */
  position?: 'absolute' | 'relative';
};

/**
 * A functional component that renders a set of actions for a card element.
 * This component wraps its children within a styled stack layout, and it supports
 * custom positioning and other props passed to it.
 */
export const Actions: FC<CardActionsProps> = ({ position = 'relative', children, ...props }) => {
  return <Stack align={'spread'} crossAxis={'base'} {...props}
    className={clsx(classes.root, { [classes.isRelative]: position === 'relative' }, props.className, 'card-actions-component')}>
    {children}
  </Stack>;
};

Actions.displayName = 'Card.Actions';